export const ON_EGRESSED = 'ON_EGRESSED';